import { useEffect } from 'react';
import { Button, Stack } from '@telescope/cassini-ui';
import { Text} from 'components';
import { Card } from './Card';
import { BingoHeadline } from './BingoHeadline';
import { useWidget } from '@telescope/cassini-hooks';
import { useBingo } from '../providers';
import TagManager from 'react-gtm-module';
import { TRACKING_ROUTES } from 'utils/constants';
import { Open } from 'generated-types/widget';

export const BingoGame = () => {
  const { data } = useWidget({ select: (data: Open) => data.snapshot.snapshot_views.bingo });
  const { content, settings } = data!;
  const { onSubmit } = useBingo();

  useEffect(() => {
    TagManager.dataLayer({ dataLayer: { event: "pageView", pageTitle: TRACKING_ROUTES.BINGO }});
  }, []);

  return (
    <Stack spacing={4}>

      <Text allowMarkdown fontSize={{base: 'sm', md: 'md'}} pb={4} textAlign={'center'}> 
        {content.description} 
      </Text>

      <BingoHeadline />

      <Card />

      { settings.displaySubmitButton &&
        <Button className="BingoCard__submit-btn" onClick={onSubmit} wordBreak="break-word"
                w="100%" minH="54px" h="auto" fontSize={{base: 'xl', md: '2xl'}} fontWeight="700">
          { content.submitButton }
        </Button> }
    </Stack>
  )
}